<template>
  <div>
    <v-card class="pa-7 transition" color="gray10">
      <div class="d-flex align-items-center">
        <v-icon>$googleAuthIcon</v-icon>
        <span class="ms-4 font-Regular-16">
          {{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.title"
            )
          }}</span
        >
      </div>
      <p class="font-Regular-16 mt-4">
        {{
          $t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.description"
          )
        }}
      </p>

      <v-row>
        <v-col
          cols="12"
          md="6"
          v-for="(item, index) in apps"
          :key="index"
          class="pa-1"
        >
          <a
            :href="item.url"
            target="_blank"
            class="w-100 d-flex align-items-center justify-space-between gray8 px-4 py-2 rounded-lg"
          >
            <div class="d-flex align-items-center">
              <span class="gray1--text">{{
                $t(
                  "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.getApp"
                )
              }}</span>
              <img
                class="ms-3"
                :src="$vuetify.theme.dark ? item.imgLight : item.imgDark"
                alt=""
                width="90"
              />
            </div>
            <v-icon clr="#500FE9">$arrowLeft</v-icon>
          </a>
        </v-col>

        <v-col cols="12" class="mt-5">
          <a
            class="d-flex align-items-center justify-space-between gray8 px-4 py-2 rounded-lg"
            href="https://www.excoino.com/blog/google-authenticator2/"
            target="_blank"
          >
            <span>{{
              $t(
                "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.guid"
              )
            }}</span>
            <v-icon clr="#500FE9">$arrowLeft</v-icon>
          </a>
        </v-col>
      </v-row>
    </v-card>
    <v-row align="stretch">
      <v-col cols="12" md="6">
        <v-card
          class="pa-4 h-100 d-flex flex-column justify-space-between"
          color="gray10"
        >
          <div>
            <v-icon>$manualIcon</v-icon>
            <span class="ms-2">{{
              $t(
                "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeAuto.title"
              )
            }}</span>
            <p class="font-Regular-12 mt-5">
              {{
                $t(
                  "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeAuto.description"
                )
              }}
            </p>
          </div>
          <v-btn color="primary" @click="activeAuto">{{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeAuto.button"
            )
          }}</v-btn>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card
          class="pa-4 d-flex flex-column justify-space-between"
          color="gray10"
        >
          <div>
            <v-icon>$manualIcon</v-icon>
            <span class="ms-2">{{
              $t(
                "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeManual.title"
              )
            }}</span>
            <p class="font-Regular-12 mt-5">
              {{
                $t(
                  "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeManual.description"
                )
              }}
            </p>
          </div>

          <a
            class="d-flex align-items-center justify-space-between gray8 px-4 py-2 rounded-lg"
            href="https://www.excoino.com/blog/google-authenticator/"
            target="_blank"
          >
            <span class="font-Regular-12">{{
              $t(
                "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeManual.guid"
              )
            }}</span>
            <v-icon clr="#500FE9">$arrowLeft</v-icon>
          </a>
          <v-btn outlined color="primary" class="mt-5" @click="nextStep">{{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeManual.button"
            )
          }}</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apps: [
        {
          imgLight: require("@/assets/image/donwloadLinksIcons/googleAuth/googlePlayLight.svg"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/googlePlayDark.svg"),
          url:
            "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
        },
        {
          imgLight: require("@/assets/image/donwloadLinksIcons/googleAuth/appStoreLight.svg"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/appStoreDark.svg"),
          url: "https://apps.apple.com/us/app/google-authenticator/id388497605 "
        },
        {
          imgLight: require("@/assets/image/donwloadLinksIcons/googleAuth/myketLight.svg"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/myketDark.svg"),
          url: "https://myket.ir/app/com.google.android.apps.authenticator2 "
        },
        {
          imgLight: require("@/assets/image/donwloadLinksIcons/googleAuth/bazarLight.svg"),
          imgDark: require("@/assets/image/donwloadLinksIcons/googleAuth/bazarDark.svg"),
          url:
            "https://cafebazaar.ir/app/com.google.android.apps.authenticator2 "
        }
      ]
    };
  },

  methods: {
    activeAuto() {
      this.$toast.info(
        this.$t(
          "accountPage.security.twoFactorAuth.modals.activeGoogle.step1.activeAuto.warning"
        )
      );
    },
    nextStep() {
      this.$emit("nextStep");
    }
  }
};
</script>

<style lang="scss" scoped></style>
